import type { CSSProperties } from 'react';

interface WordmarkProps {
  /** Font size in px. */
  size?: number;
  className?: string;
  style?: CSSProperties;
}

/**
 * NovaQuantis wordmark — vendored byte-for-byte from @novaquantis/design-system
 * so the marketing site matches the WebApp frontends exactly: "Nova" in blue,
 * "Quantis" in gold, Montserrat 700. Theme-aware via the --nq-* tokens.
 */
export function Wordmark({ size = 22, className, style }: WordmarkProps) {
  return (
    <span
      className={className}
      style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 700,
        fontSize: size,
        letterSpacing: '-0.5px',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span style={{ color: 'var(--nq-blue)' }}>Nova</span>
      <span style={{ color: 'var(--nq-gold)' }}>Quantis</span>
    </span>
  );
}
